import { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { trans } from '@spotahome/soyuz/client';

import Modal from '../Modal';
import ModalBody from '../ModalBody';
import ModalHeader from '../ModalHeader';
import BaseChip from '../BaseChip';

import './OffersLabel.scss';

import {
  getBestEligibleOffer,
  getOfferAmount,
  getOfferRange
} from '../utils/offers';

const OffersModal = ({ offers, isOpen, onClose }) => {
  const { discountValue, discountType } = getBestEligibleOffer(offers);

  return (
    <Modal isOpen={isOpen} onRequestClose={onClose}>
      <ModalHeader
        onRequestClose={onClose}
        label={trans('listing.book-now-card.offers-modal.title', {
          discount: getOfferAmount({
            discountValue,
            discountType,
            currencySymbol: ''
          })
        })}
      />
      <ModalBody className="offers-modal">
        {offers.map(
          offer =>
            getOfferRange(offer, '') && (
              <p key={offer.id}>{getOfferRange(offer, '')}</p>
            )
        )}
      </ModalBody>
    </Modal>
  );
};

OffersModal.propTypes = {
  offers: PropTypes.arrayOf(
    PropTypes.shape({
      discountType: PropTypes.string.isRequired,
      discountValue: PropTypes.number.isRequired,
      minStay: PropTypes.number.isRequired,
      maxStay: PropTypes.number
    })
  ).isRequired,
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired
};

const OffersLabel = ({
  className = '',
  offers = [],
  appliedOfferValue = null,
  clickable = false
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const classes = classNames('offers-labels', className, {
    'offers-labels--clickable': clickable
  });
  const { discountValue, discountType } = getBestEligibleOffer(offers);

  const handleOnModalClose = () => {
    setIsModalOpen(false);
  };

  const labelText = !appliedOfferValue
    ? trans('listing.book-now-card.offers-label', {
        discount: getOfferAmount({
          discountValue,
          discountType,
          currencySymbol: ''
        })
      })
    : trans('property_show.offer_price.discount', {
        discount: appliedOfferValue
      });

  const onClick = clickable ? () => setIsModalOpen(true) : null;

  return (
    <>
      <BaseChip
        className={classes}
        label={labelText}
        colorSchema="pink"
        onClick={onClick}
      />
      <OffersModal
        offers={offers}
        isOpen={isModalOpen}
        onClose={handleOnModalClose}
      />
    </>
  );
};

OffersLabel.propTypes = {
  className: PropTypes.string,
  offers: PropTypes.arrayOf(
    PropTypes.shape({
      discountType: PropTypes.string.isRequired,
      discountValue: PropTypes.number.isRequired,
      minStay: PropTypes.number.isRequired,
      maxStay: PropTypes.number
    })
  ),
  appliedOfferValue: PropTypes.string,
  clickable: PropTypes.bool
};

export default OffersLabel;
